import React, { useState } from "react";
import ErecursosTematicas from './ErecursosTematicas';
import "../css/styleErecursos.css";

const CarErecursos = ({ recurso, carnet }) => {
    const { descripcion, urlIMGVIDEO, urlLogo, accesoRemoto, prefijoid, guiasTematicas } = recurso;

    let enlace = `http://centrodeconocimiento.esen.edu.sv/sites/all/script__pruebas/accesoremoto/general.php?carne=${carnet}&db=${prefijoid}`;

    let url = "http:" + urlIMGVIDEO;

    const [verDescripcion, setVerDescripcion] = useState(false);

    return (
        <div className="card esen-resource">
            <div className="esen-resource-logo">
                <img src={urlLogo} alt={prefijoid} loading="lazy" />
            </div>
            <div className="card-body">
                <div>
                    <span className={accesoRemoto ? 'esen-chip esen-chip--success' : 'esen-chip esen-chip--info'}>
                        <i className={accesoRemoto ? 'fa fa-wifi' : 'fa fa-university'} aria-hidden="true"></i>
                        {accesoRemoto ? 'Acceso remoto' : 'Acceso campus'}
                    </span>
                </div>

                <ErecursosTematicas tematicas={guiasTematicas} />

                {verDescripcion ? (
                    <p className="mb-0" style={{ fontSize: '0.88rem' }}>{descripcion}</p>
                ) : null}

                <div className="mt-auto">
                    <div className="d-flex mb-2">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm mr-2"
                            onClick={() => setVerDescripcion(!verDescripcion)}
                            aria-expanded={verDescripcion}
                        >
                            <i className="fa fa-file-text-o mr-1" aria-hidden="true"></i>
                            {verDescripcion ? 'Ocultar info' : 'Más info'}
                        </button>
                        {urlIMGVIDEO ? (
                            <a className="btn btn-outline-primary btn-sm" href={url} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-video-camera mr-1" aria-hidden="true"></i> Video
                            </a>
                        ) : null}
                    </div>
                    <a className="btn btn-primary btn-block" href={enlace} target="_blank" rel="noopener noreferrer">
                        Ingresar
                        <i className="fa fa-arrow-right ml-2" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </div>
    )
};

export default CarErecursos;
